import { defineStore } from 'pinia';
import workApi from "@/api/workApi.js";


export const useWorksStore = defineStore('worksStore', {
    state: () => ({
        works: [],
        work: null,
        loadingWorkId: null,
    }),

    actions: {
        // Новый список по API: пагинация, поиск q, статус и фильтры
        async loadWorksList({ page = 1, search = '', status, contract, customer, facility, page_size, ordering, responsible } = {}) {
            try {
                return await workApi.getWorks({
                    page,
                    page_size,
                    q: search || undefined,
                    status,
                    contract,
                    customer,
                    facility,
                    ordering,
                    responsible
                }); // { count, results }
            } catch (error) {
                console.error('Ошибка загрузки работ:', error);
                throw error;
            }
        },
        async loadWork(id) {
            // Если уже загружаем эту работу, не делаем повторный запрос
            if (this.loadingWorkId === id) return;

            try {
                this.loadingWorkId = id;
                this.work = await workApi.getWorkDetail(id);
            } catch (error) {
                console.error('Ошибка загрузки работы:', error);
                this.work = null;
            } finally {
                this.loadingWorkId = null;
            }
        },

        async deleteWork(id) {
            try {
                await workApi.deleteWork(id);
                this.work = null;
            } catch (error) {
                console.error('Ошибка удаления работы:', error);
                throw error;
            }
        },
        async archiveWork(id) {
            try {
                await workApi.archiveWork(id);
                this.work = null;
            } catch (error) {
                console.error('Ошибка архивирования работы:', error);
                throw error;
            }
        },
        async unarchiveWork(id) {
            try {
                await workApi.unarchiveWork(id);
                await this.loadWork(id);
            } catch (error) {
                console.error('Ошибка разархивирования работы:', error);
                throw error;
            }
        },
        async loadWorkTypes({ q, department_id, is_active = true } = {}) {
            try {
                this.workTypes = await workApi.listWorkTypes({ q, department_id, is_active });
                return this.workTypes;
            } catch (error) {
                console.error('Ошибка загрузки типов работ:', error);
                throw error;
            }
        },

        async createWork({ contract, term_start, term_end, work_type, custom_name }) {
            try {
                const payload = {};
                if (contract) payload.contract = contract;
                if (term_start) payload.term_start = term_start;
                if (term_end) payload.term_end = term_end;
                if (work_type) payload.work_type = work_type;
                if (custom_name) payload.custom_name = custom_name;
                return await workApi.createWork(payload);
            } catch (error) {
                console.error('Ошибка создания работы:', error);
                throw error;
            }
        },

        async updateWork(id, { contract, term_start, term_end, work_type, custom_name }, method = 'patch') {            try {
                const payload = {};
                if (contract !== undefined) payload.contract = contract;
                if (term_start !== undefined) payload.term_start = term_start;
                if (term_end !== undefined) payload.term_end = term_end;
                if (work_type !== undefined) payload.work_type = work_type;
                if (custom_name !== undefined) payload.custom_name = custom_name;
                const updated = await workApi.updateWork(id, payload, { method });
                await this.loadWork(id);
            return updated;
            } catch (error) {
                console.error('Ошибка обновления работы:', error);
                throw error;
            }
        },

    },

});
